<template lang="pug">
  v-container.px-10(fluid)
    v-progress-linear(
      :active="loading",
      indeterminate,
      color="white",
      absolute,
      top
    )
    v-row.text-center(v-if="!entity")
      v-col.py-0
        h2.primary--text No entity selected
        small.white--text Select an entity from the sidebar list.
    v-row(v-else)
      v-col.py-0
        v-card.px-10.py-5.my-5
          v-overlay(absolute, v-if="loading")
          g-data-table(
            dense,
            :headers="headers",
            :items="paginationFiltered",
            :options.sync="options",
            :server-items-length="pagination.total",
            v-bind="{ loading }",
          )
            template(v-slot:no-data)
              h2 {{ $pascalToHuman(entityName) }} doesn't have items
              small Create an item for this entity or change search criteria.
            template(v-slot:top)
              v-row.table__top
                v-col.py-0
                  app-entity-search(
                    :criteria="$getInitialCriterias($route.params.criteria, pagination.where)",
                    :wheres="$route.params.hiddenCriteria ? [$route.params.hiddenCriteria] : []",
                    @pagination="pagination = $event",
                    :loads="loads",
                    :entity="entity",
                    :emit="true",
                    :rowsPerPage="options.itemsPerPage || null"
                  )
                v-col.pt-4(cols="auto")
                  v-dialog(v-model="dialog", persistent, max-width="725px")
                    template(v-slot:activator="{ on: dialogModal }")
                      v-tooltip(left)
                        template(v-slot:activator="{ on: tooltip }")
                          v-btn.px-0(
                            color="primary",
                            style="min-width: 40px;",
                            v-on="{ ...dialogModal, ...tooltip }"
                          )
                            v-icon mdi-cog-outline
                        span Filter columns
                    field-arrangement(
                      @close="dialog=false",
                      @selected="setHeaders"
                      :entity="entity",
                      :columns="headers"
                    )
            template(v-slot:item.user="{ item }")
              div {{ fullName(item.user) }}
            template(v-slot:item.action="{ item }")
              a(
                v-if="ShowEntityEdit(entityName)",
                style="text-decoration: none",
                @click="$savePaginationAndRoute(entityName, pagination, options, `/${$scope()}/${entityName}/${item.uid}/edit`)"
              )
                v-icon.primary--text(small) mdi-pencil
              router-link(
                v-if="ShowEntityView(entityName) && !ShowEntityEdit(entityName)",
                style="text-decoration: none",
                :to="`/${$scope()}/${entityName}/${item.uid}/view`"
              )
                v-icon.primary--text(small) mdi-eye
              app-entity-delete(:title="item.name || entityName", @confirm="remove(item)", v-if="ShowEntityDelete(entityName)")
                template(v-slot:btn="{ on }")
                  v-icon(small, color="red", v-on="on") mdi-delete
    v-row
      v-snackbar(v-model="snackbar")
        | {{ message }}
        v-btn(color="pink", text, @click="snackbar = false")
</template>

<style type="text/css">
.v-data-table td {
  white-space: nowrap;
}
.top-right {
  position: absolute;
  top: 1rem;
  right: .5rem;
}
</style>

<script>
import axios from 'axios'
import moment from 'moment-timezone'
import { mapState } from 'vuex';
import get from 'lodash/get'
import { AppEntityDelete } from '@@/components'
import AppEntityAutocomplete from '@@/components/EntityAutocomplete.vue'
import FieldArrangement from "@/components/FieldArrangement";
import EntiyLoadsMixin from "@/mixins/entity-loads.mixin";
import PaginationMixin from '@/mixins/pagination-index.mixin';
import IndexFilterMixin from '@/mixins/index-filter.mixin';

export default {
  components: {
    AppEntityDelete,
    AppEntityAutocomplete,
    FieldArrangement
  },
  name: 'entity-index',
  mixins: [
    EntiyLoadsMixin,
    PaginationMixin,
    IndexFilterMixin,
  ],
  data () {
    return {
      message: '',
      snackbar: false,
      loading: false,
      timer: null,
      wait: 500,
      pagination: {
        where: [],
      },
      options: {},
      statusList: [],
      dialog: false,
      headers: [],
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler () {
        this.clear();
        this.load(this.options);
      }
    },
    options: {
      handler (options) {
        this.load(options)
      }
    }
  },

  computed: {
    ...mapState([
      'config',
    ]),
    has () {
      return !!this.items.length
    },
    entityName () {
      return 'OrderLine'
    },
    entity () {
      return this.$searchEntity(this.entityName, 'name')
    },
    columnIndexing() {
      const headersConfig = get(this.config, `index.${this.entity.name}`);
      return headersConfig && headersConfig.length > 0 ? headersConfig :
        this.$fieldsToHeaders(
          this.entity,
          this.$fields(this.entity, 'primitive')
        );
    }
  },
  methods: {
    setHeaders(headers) {
      this.headers = headers.length ? [...headers] : this.columnIndexing;
    },
    fullName(user) {
      return `${_.get(user, 'name', '')} ${_.get(user, 'lastName', '')}`
    },

    /* TODO: docs */
    async load (options = null) {
      clearTimeout(this.timer)
      this.timer = setTimeout(async () => {
        const pagination = this.getPagination(options, this.pagination.where)
        if (this.entity) {
          this.loading = true
          try {
            //Load extraData in order to approve the entityValidation
            this.loads.push('ExtraData');
            this.loads.push('ExtraData.EExtraField');
            const paginationresult = (await axios.get(this.$fetchLoad(this.entityName, true, ...this.loads), pagination)).data;
            paginationresult.data = (paginationresult.data || []).map(d => ({
              // The date should be a UTC format, otherwise it's not going to work.
              ...d,
              // TODO: implement env ignoreTimezone here, find a way to make it generic.
              createdAt: moment(`${d.createdAt}Z`),
              modifiedAt: moment(`${d.modifiedAt}Z`),
            }));
            this.pagination = paginationresult;
          } catch (err) {}
          this.loading = false
        }
      }, this.wait)
    },

    /* TODO: docs */
    async remove (entity) {
      this.loading = true
      entity.entityState = ENV.ENTITY.STATE.DELETED
      try {
        await axios.post('entity/graph', entity)
      } catch (e) {
        this.snackbar = true
        this.message = e.response && e.response.data.message
      }
      await this.load(this.options)
    },

    clear () {
      this.options = {
        ...this.options,
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      };
    },
    getSavedPagination() {
      const { pagination, options } = this.$getSavedPagination(this.entityName);
      if(pagination && options) {
        this.pagination = pagination;
        this.options = options;
        this.load(this.options);
      }
    },
  },
  async mounted() {
    this.$store.commit('SET_ERRORS', { });
    this.headers = this.columnIndexing;
  },
  created() {
    this.getSavedPagination();
  },
}
</script>
